export const BASE_URL = "https://order-catering.com";

export const N8N_MEALS_URL =
  "https://n8n.prestigiousyachting.com/webhook/getMeals";
export const N8N_CONFIG_URL =
  "https://n8n.prestigiousyachting.com/webhook/getConfigCatering";
export const N8N_ORDER_CONFIRMATION_URL =
  "https://n8n.prestigiousyachting.com/webhook/order-catering-confirmation";

export const SPECIAL_PRODUCT_ID_B5D = "recU7DpWNdAvWBN4o";
export const SUBDOMAIN_B5D = "b5d";
